'use client';

import { Flex, Link, List, ListItem, SpriteIcon, Typography } from '@coolblue-development/freddy';
import readMoreTrigger from '@coolblue-development/ga4-events/triggers/SecondChanceDisclamer/readMoreTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import { ReactNode } from 'react';

export default function ProductCondition({
  items,
  articleUrl
}: {
  items: string[];
  articleUrl?: string;
}): ReactNode {
  const { t } = useTranslation('webshop.secondChance');
  const { trackEvent } = useAnalytics();

  if (items.length === 0 && !articleUrl) {
    return null;
  }

  return (
    <Flex gap={200} direction='column'>
      <Typography variant='h3'>{t('secondChanceProductCondition')}</Typography>
      {items.length > 0 && (
        <List columns={2}>
          {items.map((item, index) => (
            <ListItem key={`product-condition-${index}`}>{item}</ListItem>
          ))}
        </List>
      )}
      {articleUrl && (
        <Link
          startIcon={<SpriteIcon name='arrow-right' />}
          href={articleUrl}
          target='_blank'
          onClick={() =>
            trackEvent(
              readMoreTrigger({
                content: t('learnMore')
              })
            )
          }
        >
          {t('learnMore')}
        </Link>
      )}
    </Flex>
  );
}
